module.exports = __webpack_public_path__ + "static/media/plus.a0e1176d.svg";